export const handleInputMask = (key, value) => {
  switch (key) {
    case "documentNumber":
      return createCnpjMask(value);
    case "driverLicenseExpiration":
      return createDateMask(value);
    case "phone":
      return createPhoneMask(value);
    default:
      break;
  }
  return value;
};


export const createCpfMask = (value) => {
  if (!value.match(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)) {
    value = value.replace(/\D/g, "");

    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  return value;
};

export const createPhoneMask = (raw) => {
  if (!raw) return "";
  const digits = raw.replace(/\D/g, '').slice(0, 11);
  const len = digits.length;

  if (len === 0) return "";

  if (len <= 2) return `(${digits}`;
  if (len <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;

  if (len <= 10) {
    return `(${digits.slice(0,2)}) ${digits.slice(2,6)}-${digits.slice(6)}`;
  }

  return `(${digits.slice(0,2)}) ${digits.slice(2,7)}-${digits.slice(7,11)}`;
}

export const createCnpjMask = (value) => {
  if(value.length <= 11) {
    return createCpfMask(value);
  } else {
    if (!value.match(/[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}/i)) {
      value = value.replace(/[^A-Z0-9]/gi, "");

      return value.replace(
        /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/i,
        "$1.$2.$3/$4-$5"
      );
    }
  }

  return value;
};


export const createDateMask = (value) => {
  if (
    !value.match(
      /(([1-2][0-9])|([1-9])|(3[0-1]))\/((1[0-2])|([1-9]))\/[0-9]{4}/
    )
  ) {
    value = value.replace(/\D/g, "");
    return value.replace(/(\d{2})(\d{2})(\d{2})/, "$1/$2/$3");
  }
  return value;
};
